<template>
  <div class="audio-player">
    <div class="audio-body">
      <div
        :class="{
          active: state === 'playing',
          'theme-bg-primary-color': state === 'playing'
        }"
        class="vision"
      >
        <Icon
          type="md-musical-note"
          size="17"
          :class="{ 'theme-font-gray-color': state === 'playing' }"
        />
      </div>
      <div class="control" :class="{ disabled }">
        <Tooltip content="播放">
          <Icon
            @click="togglestate"
            :type="state === 'playing' ? 'md-pause' : 'md-play'"
          />
        </Tooltip>
      </div>
      <div class="progress">
        <div class="errorTips theme-font-error-color" v-if="errorMessage">
          {{ errorMessage }}
        </div>
        <Progress
          v-else
          :percent="percent"
          :stroke-width="5"
          state="active"
          ref="progress"
          hide-info
          @click.native="clickProgress"
        />
      </div>
      <div class="control" :class="{ disabled }">
        <a
          v-if="allowDownload"
          :href="src"
          :download="fileName"
          class="theme-font-darkness-color"
        >
          <Tooltip content="下载">
            <Icon type="md-download" />
          </Tooltip>
        </a>
      </div>
      <!-- <div class="volume"
           @mouseenter="volumePanel.show = true"
           @mouseleave="volumePanel.show = false">
        <Icon :type="volumePanel.percent ? 'md-volume-up':'md-volume-off'" />
        <div v-show="volumePanel.show"
             class="volume-panel">
          <Progress :percent="volumePanel.percent"
                    :stroke-width="5"
                    hide-info
                    state="active" />
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'CPlayer',
  props: {
    src: String,
    name: String,
    allowDownload: {
      type: Boolean,
      default() {
        return false
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      audio: null, // audio实例
      state: 'pause', // 播放状态
      duration: 0, // 持续时长
      progressDuration: 0, // 进度条宽度
      percent: 0, // 进度百分比
      errorMessage: '' // 错误信息
      // volumePanel: {
      //   show: false,
      //   percent: 0
      // }
    }
  },
  computed: {
    fileName() {
      if (this.name) {
        return this.name
      } else {
        return this.src.substring(this.src.lastIndexOf('/') + 1)
      }
    }
  },
  watch: {
    src: {
      handler(newValue) {
        if (newValue) {
          this.init(newValue)
        }
      },
      immediate: true
    },
    disabled: {
      handler(newValue) {
        if (newValue) {
          this.errorMessage = '不可播放'
        } else {
          this.errorMessage = ''
        }
      },
      immediate: true
    }
  },
  mounted() {
    if (this.$refs.progress) {
      this.progressDuration = this.$refs.progress.$el.children[0].children[0].clientWidth
    }
  },
  methods: {
    init(src) {
      this.resetAudio()
      this.audio = new Audio(src)
      this.audio.preload = 'metadata'
      // 媒体元数据加载完成
      this.audio.onloadedmetadata = () => {
        this.errorMessage = ''
        this.duration = this.audio.duration
      }
      // 监听播放结束
      this.audio.onended = () => {
        this.state = 'pause'
      }
      // 监听播放进度
      this.audio.ontimeupdate = () => {
        this.percent = (this.audio.currentTime / this.duration) * 100
      }
    },
    togglestate() {
      if (this.disabled) return
      if (!this.audio) return
      if (this.state === 'playing') {
        this.audio.pause()
        this.state = 'pause'
      } else {
        if (this.audio.readyState > 0) {
          this.audio.play()
          this.state = 'playing'
          this.errorMessage = ''
        } else {
          this.errorMessage = '音频未就绪，不可播放。'
        }
      }
    },
    clickProgress(e) {
      if (
        e.target.classList.contains('ivu-progress-inner') ||
        e.target.classList.contains('ivu-progress-bg')
      ) {
        if (this.state === 'playing') {
          let percent = (e.offsetX / this.progressDuration) * 100
          this.audio.currentTime = (percent / 100) * this.duration
          this.percent = percent
        }
      }
    },
    resetAudio() {
      this.audio && this.audio.pause()
      this.audio = null
      this.state = 'pause'
      this.duration = 0
      this.progressDuration = 0
      this.percent = 0
      this.errorMessage = ''
    }
  },
  beforeDestroy() {
    this.resetAudio()
  }
}
</script>
<style lang="stylus">
@keyframes rotate
  from
    transform rotate(0deg)

  to
    transform rotate(360deg)

.audio-player
  padding 10px 0

  .audio-body
    display flex
    align-items center
    border 1px solid #eeeeee
    height 40px
    border-radius 20px
    background #fff

    .ivu-icon
      font-size 15px

    .vision
      display flex
      justify-content center
      align-items center
      height 30px
      flex 0 0 30px
      margin-left 5px
      border-radius 50%
      background #eee
      animation rotate infinite 3s linear
      animation-play-state paused
      transition background 0.5s

      &.active
        animation-play-state running

    .control
      flex 0 0 50px
      text-align center
      cursor pointer

      &.disabled
        pointer-events none
        cursor not-allowed

    .progress
      flex 1 1 auto
      margin-right 10px

    .errorTips
      line-height 1
      font-size 14px
</style>